import { debounce } from "lodash";

export const enforceZIndexUnderCurrentId =
    "enforce-header-container-zindex-is-0-that-makesure-it-under-filter-nav-bar";

export const changeView = (action: "add" | "remove") => {
    if (typeof window === "undefined") return;
    const targetElement = document.getElementById("BTemplateSwiper");
    if (targetElement && targetElement.parentElement) {
        const siblings = Array.from(
            targetElement.parentElement.children,
        ).filter(
            (child) =>
                child !== targetElement && child.id !== "filterNavBarContainer",
        ); // 过滤掉目标元素

        siblings.forEach((sibling) => {
            if (action === "add") {
                sibling.classList.add("hidden"); // 添加类名
                window.addEventListener("resize", updateHeight);
            } else if (action === "remove") {
                sibling.classList.remove("hidden"); // 删除类名
                window.removeEventListener("resize", updateHeight);
            }
        });
    }
};
export const updateHeight = debounce(() => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
}, 500);
// 目前只上线了es站点
export const isNewBTemplate = (site: string) => {
    return false
    if (site === "es" || site === 'au') return true;
};
